import { ROUTE_PATHS } from '../config/navigation';
import managedContent from './managedContent.json';

const routePathMap = {
  hr: ROUTE_PATHS.hr,
  applications: ROUTE_PATHS.applications,
  dashboard: ROUTE_PATHS.dashboard,
  selfService: ROUTE_PATHS.selfService,
  directory: ROUTE_PATHS.directory,
  announcements: ROUTE_PATHS.announcements,
  documents: ROUTE_PATHS.documents,
  surveys: ROUTE_PATHS.surveys,
  innovation: ROUTE_PATHS.innovation,
  events: ROUTE_PATHS.events
};

const resolvePath = (item) => item.path || routePathMap[item.pathKey] || ROUTE_PATHS.dashboard;

export const hydrateSelfServiceContent = (content) => ({
  lunchMenu: content.lunchMenu || [],
  shuttleRoutes: content.shuttleRoutes || [],
  expenseLinks: (content.expenseLinks || []).map((item) => ({
    ...item,
    path: resolvePath(item)
  })),
  techFaqs: content.techFaqs || [],
  operationsContacts: content.operationsContacts || [],
  supportCategories: content.supportCategories || [],
  urgencyOptions: content.urgencyOptions || []
});

const selfServiceContent = hydrateSelfServiceContent(managedContent.selfService);

export const {
  lunchMenu,
  shuttleRoutes,
  expenseLinks,
  techFaqs,
  operationsContacts,
  supportCategories,
  urgencyOptions
} = selfServiceContent;

export const getSelfServiceContentFallback = () => ({
  lunchMenu: [...lunchMenu],
  shuttleRoutes: [...shuttleRoutes],
  expenseLinks: [...expenseLinks],
  techFaqs: [...techFaqs],
  operationsContacts: [...operationsContacts],
  supportCategories: [...supportCategories],
  urgencyOptions: [...urgencyOptions]
});

export default selfServiceContent;
